export default "__VITE_PUBLIC_ASSET__d897dcec__"